import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { debounce } from '../../../../helpers/common'
import { MAX_PORTFOLIO } from '../../../../utils/common'
import { Button } from '../../../html/button'
import { PopupAction } from '../../../popup/PopupAction'
import { SCORE_MODE_ID } from '../../constant'
import {
  changeDataSetting,
  changeParamsSetting,
  saveOnly,
  selectDataSettingDefault,
} from '../../store/slice'
import {
  covertDataAgeById,
  selectListSelectedBusinessAge,
} from '../../store/sliceBusinessAge'
import { selectListSelectedBusinessSize } from '../../store/sliceBusinessSize'
import {
  convertDataIndustrySelectById,
  selectIndustry,
} from '../../store/sliceIndustry'
import {
  covertDataPortById,
  selectIsAllCheck,
  selectListSelected,
  selectListSelectedCompanyExclude,
} from '../../store/slicePortfolio'
import {
  covertDataProvinceById,
  selectListSelectedProvince,
} from '../../store/sliceProvince'
import {
  coverDataScoreLevelById,
  selectDataScoreLevelRange,
  selectLogicalOperator,
  selectScore,
  selectTypePeriod,
} from '../../store/sliceScoreLevel'
import { selectLoadingTotalCompanies } from '../../store/sliceTotalCompanies'
import {
  getCompanies,
  getTotalCompanyBySettings,
  postSaveFilter,
} from '../../store/thunk'
import { TYPE_PERIOD_TIME, TYPE_SCORE_VAlUE } from '../constant'
import { convertListId, covertTagDataIndustry } from '../helper'

const style = {
  backgroundColor: '#FFFFFF',
  border: '1px solid #D5D5D5',
  borderRadius: '4px',
  padding: '5px 12px',
  textTransform: 'capitalize',
}

const styleDisable = {
  pointerEvents: 'none',
  opacity: 0.6,
  backgroundColor: '#D5D5D5',
}

export const GroupBtnAction = ({ filterType, onSaveDefault, onSave }) => {
  const dispatch = useDispatch()

  const [isShowDefault, setShowDefault] = useState(false)

  const listParentChecked = useSelector(selectIndustry('listParentChecked'))
  const data = useSelector(selectIndustry('industryVSICById'))
  const loadingFilterCompanies = useSelector(selectLoadingTotalCompanies)

  const isAll = useSelector(selectIsAllCheck)
  const listIdPortfolio = useSelector(selectListSelected)
  const listExclude = useSelector(selectListSelectedCompanyExclude)
  const listSelectedProvince = useSelector(selectListSelectedProvince)
  const listSelectedIndustry = covertTagDataIndustry(data, listParentChecked)
  const listSelectedBusinessSize = useSelector(selectListSelectedBusinessSize)
  const listSelectedBusinessAge = useSelector(selectListSelectedBusinessAge)

  //CustomScore
  const typePeriod = useSelector(selectTypePeriod)
  const typeLogicalOperator = useSelector(selectLogicalOperator)

  const dataDefault = useSelector(selectDataSettingDefault)
  const {
    portfolioId,
    bussinessAgeId,
    excludeId,
    industryId,
    provinceId,
    scoreLevelObj,
  } = dataDefault

  //Portfolio
  const scoreCreditCurrent = useSelector(
    selectScore(
      [TYPE_SCORE_VAlUE.CREDIT_SCORE, TYPE_PERIOD_TIME.CURRENT],
      (data) => {
        const dataFiinGate = Object.keys(data.fiinGate).filter(
          (item) => data.fiinGate[item],
        )
        const dataCustom = Object.values(data.custom).filter(
          (item) => item?.From || item?.To,
        )
        return {
          custom: dataCustom?.length
            ? dataCustom
            : [{ From: undefined, To: undefined }],
          fiinGate: dataFiinGate,
        }
      },
    ),
  )

  const scoreCreditPrevious = useSelector(
    selectScore(
      [TYPE_SCORE_VAlUE.CREDIT_SCORE, TYPE_PERIOD_TIME.PREVIOUS],
      (data) => {
        const dataFiinGate = Object.keys(data.fiinGate).filter(
          (item) => data.fiinGate[item],
        )
        const dataCustom = Object.values(data.custom).filter(
          (item) => item?.From || item?.To,
        )
        return {
          custom: dataCustom?.length
            ? dataCustom
            : [{ From: undefined, To: undefined }],
          fiinGate: dataFiinGate,
        }
      },
    ),
  )

  const scorePerformanceCurrent = useSelector(
    selectScore(
      [TYPE_SCORE_VAlUE.PERFORMANCE_SCORE, TYPE_PERIOD_TIME.CURRENT],
      (data) => {
        const dataFiinGate = Object.keys(data.fiinGate).filter(
          (item) => data.fiinGate[item],
        )
        const dataCustom = Object.values(data.custom).filter(
          (item) => item?.From || item?.To,
        )
        return {
          custom: dataCustom?.length
            ? dataCustom
            : [{ From: undefined, To: undefined }],
          fiinGate: dataFiinGate,
        }
      },
    ),
  )
  const scorePerformancePrevious = useSelector(
    selectScore(
      [TYPE_SCORE_VAlUE.PERFORMANCE_SCORE, TYPE_PERIOD_TIME.PREVIOUS],
      (data) => {
        const dataFiinGate = Object.keys(data.fiinGate).filter(
          (item) => data.fiinGate[item],
        )
        const dataCustom = Object.values(data.custom).filter(
          (item) => item?.From || item?.To,
        )
        return {
          custom: dataCustom?.length
            ? dataCustom
            : [{ From: undefined, To: undefined }],
          fiinGate: dataFiinGate,
        }
      },
    ),
  )
  const dataRangeScore = useSelector(selectDataScoreLevelRange)

  const paramSetting = {
    portfolioIds: isAll ? [] : convertListId(listIdPortfolio),
    excludeIds: convertListId(listExclude),
    scoreLevel: {
      PeriodType: typePeriod.value,
      LogicalOperator: typeLogicalOperator.value,
      CurrentCreditRiskScore: {
        ListLevelScoreChecked: scoreCreditCurrent.fiinGate.map(Number),
        isCustom: true,
        ListCustomRanges:
          scoreCreditCurrent.fiinGate.length ===
          dataRangeScore[SCORE_MODE_ID.CORPORATE_RISK].length
            ? [{ From: undefined, To: undefined }]
            : scoreCreditCurrent.custom,
      },
      PreviousCreditRiskScore: {
        ListLevelScoreChecked: scoreCreditPrevious.fiinGate.map(Number),
        isCustom: true,
        ListCustomRanges:
          scoreCreditPrevious.fiinGate.length ===
          dataRangeScore[SCORE_MODE_ID.CORPORATE_RISK].length
            ? [{ From: undefined, To: undefined }]
            : scoreCreditPrevious.custom,
      },
      CurrentPerformanceScore: {
        ListLevelScoreChecked: scorePerformanceCurrent.fiinGate.map(Number),
        isCustom: true,
        ListCustomRanges:
          scorePerformanceCurrent.fiinGate.length ===
          dataRangeScore[SCORE_MODE_ID.PERFORMANCE].length
            ? [{ From: undefined, To: undefined }]
            : scorePerformanceCurrent.custom,
      },
      PreviousPerformanceScore: {
        ListLevelScoreChecked: scorePerformancePrevious.fiinGate.map(Number),
        isCustom: true,
        ListCustomRanges:
          scorePerformancePrevious.fiinGate.length ===
          dataRangeScore[SCORE_MODE_ID.PERFORMANCE].length
            ? [{ From: undefined, To: undefined }]
            : scorePerformancePrevious.custom,
      },
    },
    provinceIds: convertListId(listSelectedProvince),
    industryIds: convertListId(listSelectedIndustry),
    bussinessSizeIds: convertListId(listSelectedBusinessSize),
    bussinessAgeIds: convertListId(listSelectedBusinessAge),
  }

  const handleSaveDefault = () => {
    dispatch(saveOnly(false))
    dispatch(
      postSaveFilter({
        ...paramSetting,
        portfolioIds: isAll ? [] : paramSetting.portfolioIds,
        filterType,
      }),
    )
    dispatch(changeParamsSetting(paramSetting))
    dispatch(changeDataSetting(paramSetting))
    onSaveDefault && onSaveDefault()
  }

  const handleCancel = () => {
    dispatch(saveOnly(true))
    dispatch(covertDataPortById(portfolioId))
    dispatch(covertDataProvinceById(provinceId))
    dispatch(convertDataIndustrySelectById(industryId))
    dispatch(covertDataAgeById(bussinessAgeId))

    excludeId.length &&
      dispatch(
        getCompanies({
          page: 1,
          pageSize: MAX_PORTFOLIO,
          organizationIds: excludeId,
        }),
      )

    Object.keys(scoreLevelObj).length &&
      dispatch(coverDataScoreLevelById(scoreLevelObj))

    onSave && onSave()
  }

  const handleSaved = () => {
    dispatch(saveOnly(true))
    dispatch(changeParamsSetting(paramSetting))
    dispatch(changeDataSetting(paramSetting))
    onSave && onSave()
  }

  const handleGetTotalCompanies = useCallback(
    debounce((settings) => {
      dispatch(getTotalCompanyBySettings(settings))
    }, 300),
    [],
  )

  const onCloseConfirmDefault = () => {
    setShowDefault(false)
  }

  useEffect(() => {
    handleGetTotalCompanies(paramSetting)
  }, [JSON.stringify(paramSetting)])

  return (
    <div className="dFlex gap1 justifyContentEnd">
      <Button
        className="cursorPointer"
        label="library.filterSetting.CANCEL"
        action={handleCancel}
        isI18n
        style={
          loadingFilterCompanies ? { ...style, ...styleDisable } : { ...style }
        }
      />
      <Button
        className="cursorPointer"
        label="library.filterSetting.SET_DEFAULT"
        action={() => setShowDefault(true)}
        isI18n
        style={
          loadingFilterCompanies ? { ...style, ...styleDisable } : { ...style }
        }
      />
      <Button
        className="cursorPointer"
        label="library.filterSetting.APPLY"
        action={handleSaved}
        isI18n
        style={
          loadingFilterCompanies
            ? { ...style, ...styleDisable }
            : { ...style, backgroundColor: '#2C73E8', color: '#FFFFFF' }
        }
      />
      {isShowDefault && (
        <PopupAction
          isShow={isShowDefault}
          title="library.main.CONFIRM"
          handleClose={onCloseConfirmDefault}
          btnCancel={{
            label: 'common.NO',
            isI18n: true,
            event: onCloseConfirmDefault,
          }}
          btnSubmit={{
            label: 'common.YES',
            isI18n: true,
            event: handleSaveDefault,
          }}
        >
          <Translate value="library.main.NOTI_CONFIRM" />
        </PopupAction>
      )}
    </div>
  )
}
